import { baseThemeValues } from 'constants/common';

import { menuButtonTheme } from './MenuButton/theme';

const navigationItemBase = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '16px',
};

export const navigationBarTheme = {
  container: 'palette.surface.3',
  logoutModalMessage: 'palette.tertiary.90',
  navigationItem: {
    active: {
      ...navigationItemBase,
      bg: 'palette.surface.5',
      borderColor: 'palette.primary.10',
      borderWidth: '4px',
      text: 'palette.neutral.90',
    },
    base: {
      ...navigationItemBase,
      bg: 'palette.surface.3',
      borderColor: 'palette.transparent',
      borderWidth: '4px',
      text: 'palette.tertiary.60',
    },
    expanded: {
      ...navigationItemBase,
      bg: 'palette.surface.5',
      borderColor: 'palette.surface.5',
      borderWidth: '4px',
      text: 'palette.neutral.50',
    },
    hover: {
      ...navigationItemBase,
      bg: 'palette.primary.10',
      borderColor: 'palette.transparent',
      borderWidth: '4px',
      text: 'palette.primary.95',
    },
    mainItem: {
      fontWeight: 500,
    },
    navigationItemBase,
    subItem: {
      fontWeight: 400,
    },
  },
  openButton: menuButtonTheme,
};
